import React, { useState } from 'react';
import { css } from 'aphrodite';
import { Col, Row } from 'antd';
import { SubscriptionCard } from '../../../common/subscription-card';
import { convertPxToRem, translate } from '../../../helper';
import { SVGImageComponentReact } from '../../../themes/Images';
import { subscriptionTerms, subscriptionType, WORK_FLOW_COMMON_SCREENS } from '../const';
import { useScreenSubscription } from '../screenProviderLocationAccount';
import { styles } from '../styles';

export const PurchaseLocation = () => {
    const [isYearly, setIsYearly] = useState(false);
    const { subscriptionProduct, navigateTo, setSelectedSubscription, childAccount, goBack } = useScreenSubscription();
    
    if (!subscriptionProduct) {
        return <p>{translate('noSubscriptionData')}</p>;
    }

    const selectedPlan = subscriptionProduct.prices.find(
        price => price.recurring_interval === ( isYearly ? subscriptionType.YEAR : subscriptionType.MONTH )
    );

    const selectedSubscription = {
        title: 'locationSubAccount',
        subTitle: isYearly ? 'yearlySubscription' : 'monthlySubscription',
        paymentId: selectedPlan.id,
        price: selectedPlan?.price || subscriptionType.DEFAULT_VALUE,
        recurringInterval: selectedPlan?.recurring_interval || subscriptionType.DEFAULT_VALUE,
        percentageDiscount: selectedPlan?.discount || subscriptionType.DEFAULT_VALUE
    };

    const showPurchaseLocation = () => {
        navigateTo(WORK_FLOW_COMMON_SCREENS.PAYMENT_INFO);
        setSelectedSubscription(selectedSubscription)
    }

    return ( 
        <>
            { childAccount?.id && 
                <Row justify="space-between">
                    <Col>
                        <Row>
                            <div
                            style={{ marginLeft: convertPxToRem(33) , marginTop: convertPxToRem(33) }}
                            className="flex-row-center-center cursor-pointer"
                            onClick={goBack}
                            >
                                <SVGImageComponentReact.IconArrowBack />
                            </div>
                        </Row>
                    </Col>
                </Row>
            }
        
            <div className={css(styles.subscriptionContainer)}>
                <SubscriptionCard
                    isYearly={isYearly}
                    title={'locationSubAccount'}
                    subTitle={isYearly ? 'yearlySubscription' : 'monthlySubscription'}
                    subscription={{
                        price: selectedPlan?.price || subscriptionType.DEFAULT_VALUE,
                        recurring_interval: selectedPlan?.recurring_interval || subscriptionType.DEFAULT_VALUE,
                        discount: selectedPlan?.discount || subscriptionType.DEFAULT_VALUE
                    }}
                    terms={[
                        subscriptionTerms.TERMCHILD1, 
                        subscriptionTerms.TERMCHILD2, 
                    ]}
                    pricelist={subscriptionProduct.prices}
                    showEmpty={subscriptionProduct.prices.length <= 1}
                    onChange={() => setIsYearly(prev => !prev)}
                    onPurchase={() => showPurchaseLocation()}
                />
            </div>
        </>
    );
};

PurchaseLocation.propTypes = {};